import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { AppRouterConstants } from '../../components/appRouter/AppRouter.constants'
import { Userpilot as userPilotNative } from '@userpilot/capacitor'
import { Userpilot as userPilotWeb } from 'userpilot'
import { isPlatformWeb } from '../../utilities'
import Logger from '../../services/logger.service'
import { TabConstants } from '../../components/tabs/Tabs.constants'
import { isUserpilotEnabled } from './initialize'

const TRACKED_PATHS = [AppRouterConstants.CREW_ROUTE, TabConstants.COMPLETE_CHART_TAB]

export const UserpilotScreenTracker = () => {
  const { location } = useLocation()

  useEffect(() => {
    const pathname = location?.pathname

    if (!pathname || !isUserpilotEnabled() || !TRACKED_PATHS.includes(pathname)) return

    try {
      if (isPlatformWeb()) {
        userPilotWeb.reload()
      } else {
        const title = pathname.split('/').filter(Boolean).slice(-1)[0]
        userPilotNative.screen({ title })
      }
      Logger.info(`Userpilot screened on page: ${pathname}`)
    } catch (err) {
      Logger.errorObj(`Failed to reload Userpilot on ${pathname}`, err)
    }
  }, [location])

  return null
}
